import React, { useEffect, useRef } from "react";
import { Section } from "../../styles";
import PrimaryHeading from "../../DesignSystem/PrimaryHeading";
import { GridBox } from "../../UIComponents/FourGrid/styles";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { BackgroundImage } from "../../styles";
import Img2 from "../../../assets/images/frame.svg";
import Img21 from "../../../assets/images/21.png";
import Img22 from "../../../assets/images/22.png";
import E1 from "../../../assets/images/e1.svg";
import E2 from "../../../assets/images/e2.svg";

export default function Ecommerce() {
  const canvasRef = useRef(null);

  const webAR1 = require("../../../assets/three/chair.glb");

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      750,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    const renderer = new THREE.WebGLRenderer({
      canvas: canvasRef.current ?? document.createElement("canvas"),
    });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x000000, 0);

    const loader = new GLTFLoader();
    loader.load(webAR1, (gltf) => {
      const model = gltf.scene;
      model.position.set(0, 0, 0);
      scene.add(model);

      const animate = () => {
        requestAnimationFrame(animate);

        // Rotate the model
        model.rotation.y += 0.01; // Adjust the rotation speed as needed

        renderer.render(scene, camera);
      };

      animate();
    });

    const controls = new OrbitControls(camera, renderer.domElement);
    camera.position.set(2, 1, 3);
    controls.update();

    const pointLight = new THREE.PointLight(0xffffff, 1);
    pointLight.position.set(2, 1, 5);
    scene.add(pointLight);
  });

  return (
    <div>
      <section className="bg-dark py-5rem">
        <div className="container pt-0 pt-sm-5">
          <div className="row pt-3 pb-2 py-md-4 align-items-center">
            <div className="col-12 col-sm-6 order-0 animate__animated animate__fadeInLeft">
              <PrimaryHeading
                primaryText="Explore Realistic Product Visualization and Interactive Shopping"
                className="text-white align-items-start text-gradient-light"
              />
              <h2 className="text-white">Visualize Sofa Prices in AR/VR</h2>

              <p className="mb-4 pb-4 text-white">
                Experience a new level of online shopping with AR-integrated
                apps that bring realistic product visualization to your
                fingertips. Preview items in your own environment, try on
                virtual makeup, or envision furniture in your home before making
                a purchase.
              </p>
            </div>
            <div className="col-12 col-sm-6 order-1 pt-5 pt-sm-0 animate__animated animate__fadeInRight">
              <img
                src={E1}
                className="card-img card-img-bottom bg-size-cover bg-repeat-0 bg-position-center"
                alt="Home Interior"
              />
            </div>
          </div>
        </div>
      </section>

      <BackgroundImage
        className="bg-gradiant1 py-5rem"
        style={{
          background: `url(${Img2})`,
        }}
      >
        <div className="container ">
          <Section className="mt-n1 mt-md-0 py-5 animate__animated animate__fadeInUp">
            <div className="row m-0 d-flex align-items-center">
              <div className="col-12 col-sm-6  mt-5 mt-sm-0 order-1 order-sm-0">
                <img src={E2} alt="Home Interior" />
              </div>
              <div className="col-12 col-sm-6   order-0 order-sm-1 ps-0 ps-sm-5">
                <div className="rs-breadcrumbs img4 aws-banner">
                  <div className="container">
                    <div className="">
                      <PrimaryHeading
                        primaryText="VR Shopping Transformation"
                        className="text-white align-items-start"
                      />
                      <p className="sub-text text-white">
                        Transform the shirt shopping experience with VR
                        technology, offering immersive 360-degree views that
                        allow customers to visualize and interact with products
                        before making a purchase. Eliminate the need for
                        physical try-ons and empower shoppers to make confident
                        decisions online.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Section>
        </div>
      </BackgroundImage>

      <Section>
        <div className="container position-relative">
          <div className="row justify-content-center text-center">
            <div className="col-xl-9 col-lg-9 col-md-9">
              <PrimaryHeading primaryText="AR and VR revolutionize e-commerce shopping experiences." />
              <p className="fs-5 mb-4 pb-4 ">
                Experience intuitive and immersive shopping, transforming the
                way businesses operate.
              </p>
            </div>
          </div>
          <div>
            <div className="row g-4 pb-2 pb-sm-4 mb-sm-2">
              <div className="col-12 col-sm-6">
                <GridBox>
                  <div className="d-flex align-items-center justify-content-between">
                    <h3 className="m-0">
                      Experience
                      <span className="text-warning"> Virtual</span> for Brand
                      Awareness
                    </h3>
                    {/* <CanvasContainer>
                      <canvas
                        ref={canvasRef}
                        style={{
                          width: 100,
                          height: "100%",
                        }}
                      />
                    </CanvasContainer> */}
                    <img
                      src={Img21}
                      alt="Home Interior"
                      className="w-100 d-none d-sm-block"
                    />
                  </div>
                  <div>
                    <p className="text-left mb-3">
                      <img
                        src={Img21}
                        alt="Home Interior"
                        className="w-100 d-block d-sm-none"
                      />
                      virtual experiences that showcase your brand attributes
                      and allow customers to explore the benefits firsthand,
                      increasing awareness and engagement.
                    </p>
                  </div>
                </GridBox>
              </div>
              <div className="col-12 col-sm-6">
                <GridBox>
                  <div className="d-flex align-items-center justify-content-between">
                    <h3 className="m-0">
                      Captivating
                      <span className="text-warning"> Marketing</span> Campaigns
                    </h3>
                    {/* <CanvasContainer>
                      <canvas
                        ref={canvasRef}
                        style={{
                          width: 100,
                          height: "100%",
                        }}
                      />
                    </CanvasContainer> */}
                    <img
                      src={Img22}
                      alt="Home Interior"
                      className="w-100 d-none d-sm-block"
                    />
                  </div>
                  <div>
                    <p className="text-left mb-3">
                      <img
                        src={Img22}
                        alt="Home Interior"
                        className="w-100 d-block d-sm-none"
                      />
                      Engage customers with innovative AR/VR marketing campaigns
                      that captivate their attention and drive desired
                      behaviors.
                    </p>
                  </div>
                </GridBox>
              </div>
            </div>
          </div>
        </div>
      </Section>

      {/* <Section className="bg-black">
        <div className="rs-about">
          <div className="container custom">
            <div className="m-0 row">
              <div className="col-lg-12 pl-60 md-pl-15">
                <div className="sec-title">
                  <h2 className="title pb-22 text-white">
                    We're here to help! At AllesXR, we're passionate about
                    providing exceptional augmented reality. our team is ready
                    to assist you.
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section> */}
    </div>
  );
}
